import React, { useState, Fragment } from "react";
import { Transition } from "@headlessui/react";

//COMPONENTS
import { HeaderLaptop, HeaderMobile } from "../components/Header";
import ServiceContent from "../components/ServiceContent";
import Cta from "../components/Cta";
//ASSETS
import HrSolutionsImage from "../assets/hr-solutions-header.svg";
import HRSImg1 from "../assets/hr-solutions-1.svg";
import HRSImg2 from "../assets/hr-solutions-2.svg";

const content = [
  {
    text: (
      <p>
        At Nectar Consulting we are able to offer a full HR outsourcing service 
        for employers looking to reduce risks and overhead costs so more time 
        can be spent on revenue-generating activities. Whether you want a one-off 
        employment contract or a fully managed HR solution, we can help you.
        <br/>
        We strive to support small to medium sized businesses by finding out what 
        you need so you get the best level of service for your unique organisation.
      </p>
    ),
    img: HRSImg1,
  },
  {
    text: (
      <p>
        So whether you have a full HR Department or you are looking after HR yourself, 
        we have a solution that will help you.
        <br/>
        Our HR Service can be taken as a complete package or a one-off single element of
        our services such as Employment Contracts or Unlimited HR Advice.
        <br/>
        We invite you to work, better and smarter by using our services to coordinate all 
        of your HR functions, supplement your current HR function, or act as HR consultants.
      </p>
    ),
    img: HRSImg2,
  },
];

const HrSolutions = () => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div>
      <HeaderLaptop
        titlePart1="Human Resources"
        titlePart2=" Solutions"
        pageSnippet="A company’s most valuable asset is its employees."
        headerIllustration={HrSolutionsImage}
        alt="Human resources team"
      />
      <HeaderMobile
        titlePart1="Human Resources"
        titlePart2=" Solutions"
        pageSnippet="A company’s most valuable asset is its employees."
        headerIllustration={HrSolutionsImage}
        alt="Human resources team"
      />

      <div className="max-w-7xl mx-auto px-4 my-16 sm:px-6 lg:mt-32">
        <h2 className="header2 text-center">
          We offer you a<span className="text-earth"> full HR </span>solution
        </h2>
        <p className="text-center mt-8">
          The services we provide are completely individualised to your business – we will never 
          give you a ‘one size fits all’ contract, handbook, or policy. This means that we will 
          provide tailored HR solutions that are specific to your goals, and gives you complete 
          eace of mind that your legal obligations are covered.
          <br/>
          We are also experts in honesty as well as HR, and we’ll never try to sell you something 
          you don’t need. We build strong relationships with our clients based on trust, respect, 
          and a shared goal of business growth.
        </p>
        {content.map((item, index) => (
          <ServiceContent
            key={index}
            isLast={index === content.length - 1}
            img={item.img}
            alt={item.alt}
            text={item.text}
            isLeftAlign={index % 2}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 my-20 sm:px-6">
        <Transition
          as={Fragment}
          show={isVisible}
          enter="duration-200 ease-out"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="duration-100 ease-in"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="">
            <h3 className="header3 text-center">Our HR Solutions include:</h3>
            <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 lg:gap-48">
              <ul>
                <li>• HR Services Include</li>
                <li>• Appraisal/ Performance evaluation forms</li>
                <li>• Self-appraisal form</li>
                <li>• Capability procedure</li>
                <li>• Medical capability procedure including consent forms etc</li>
                <li>• Disciplinary procedures/ policy</li>
                <li>
                  • Investigation/ Disciplinary documentation including warnings,
                  suspension and dismissal documentation
                </li>
                <li>• Grievance policy and documentation</li>
                <li>
                  • Redundancy documentation including assessment forms, letters and
                  consultation documentation
                </li>
                <li>• Settlement agreement</li>
                <li>• Recruitment policy</li>
                <li>• Interview assessments</li>
                <li>• Designing Job Adverts</li>
                <li>• Right to work checks procedures and training</li>
                <li>• Offer of Appointment letter</li>
                <li>• Contracts of Employment for permanent employees</li>
              </ul>
              <ul>
                <li>• Restrictive covenant clauses</li>
                <li>• Zero hour contract of employment</li>
                <li>• Job Descriptions</li>
                <li>• Opt Out form</li>
                <li>• Application form</li>
                <li>• Exit interview/ questionnaire</li>
                <li>• Flexible Working Policy</li>
                <li>• Health and Safety Policy and review</li>
                <li>• Modern Slavery Act Policy</li>
                <li>• Whistleblowing Policy</li>
                <li>• Maternity Policy and documentation </li>
                <li>• Paternity Policy and documentation</li>
                <li>• Sickness Absence Policy and procedures</li>
                <li>• Return to work documentation and advice</li>
                <li>• Training Costs Agreement - claw back clause</li>
                <li>• TUPE Advice, support and documentation</li>
                <li>• GDPR Policy review and implementation</li>
                <li>• Sponsorship licence registration and audit</li>
                <li>• Employee Handbook review and implementation</li>
              </ul>
            </div>
          </div>
        </Transition>
        <div className="w-full flex justify-center">
          <button
            onClick={() => setIsVisible(!isVisible)}
            className="mt-8 bg-earth rounded-md shadow-md py-4 px-8 whitespace-nowrap text-base font-medium text-white"
          >
            {isVisible ? "View less" : "View all our HR services"}
          </button>
        </div>
      </div>
      <Cta />
    </div>
  );
};

export default HrSolutions;
